import React from 'react';
import { Route } from 'react-router-dom';
import WhyChooseUsSection from '../pages/why-choose-us/WhyChooseUsSection';
import WhyChooseUsListPage from '../pages/why-choose-us/WhyChooseUsListPage';
import CreateWhyChooseUsItem from '../pages/why-choose-us/CreateWhyChooseUsItem';
import EditWhyChooseUsItem from '../pages/why-choose-us/EditWhyChooseUsItem';
import ProtectedRoute from '../components/global/ProtectedRoute';

const whyChooseUsRoutes = (
    <>
        <Route
            path="/why-choose-us/section"
            element={<ProtectedRoute requiredPermission="settings.why-choose-us.view"><WhyChooseUsSection /></ProtectedRoute>}
        />
        <Route
            path="/why-choose-us"
            element={<ProtectedRoute requiredPermission="why-choose-us.view"><WhyChooseUsListPage /></ProtectedRoute>}
        />
        <Route
            path="/why-choose-us/create"
            element={<ProtectedRoute requiredPermission="why-choose-us.create"><CreateWhyChooseUsItem /></ProtectedRoute>}
        />
        <Route
            path="/why-choose-us/:id/edit"
            element={<ProtectedRoute requiredPermission="why-choose-us.update"><EditWhyChooseUsItem /></ProtectedRoute>}
        />
    </>
);

export default whyChooseUsRoutes;
